<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				label="报备流程"
				placeholder="选择报备流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择备流程' }]"
			/>
			<van-field
				v-model="client_id_text"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.select = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="form.xmmc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目名称' }]"
			/>
			<van-field
				v-model="form.xmbh"
				label="项目编号"
				placeholder="输入项目编号"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目编号' }]"
			/>
			<van-field
				v-model="form.xmxh"
				label="项目型号"
				placeholder="输入项目型号"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目型号' }]"
			/>
			<van-field
				v-model="form.xmcchzmj"
				label="项目尺寸或总面积"
				placeholder="输入项目尺寸或总面积"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目尺寸或总面积' }]"
			/>
			<van-field
				v-model="form.xmdz"
				label="项目地址"
				placeholder="输入项目地址"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入项目地址' }]"
			/>
			<van-field
				v-model="form.bbgs"
				label="报备公司"
				placeholder="输入报备公司"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入报备公司' }]"
			/>
			<van-field
				v-model="form.sfgw"
				label="是否挂网"
				placeholder="输入是否挂网"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入是否挂网' }]"
			/>
			<van-field
				v-model="form.bbgsdjr"
				label="报备公司对接人"
				placeholder="输入报备公司对接人"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入报备公司对接人' }]"
			/>
			<van-field
				v-model="form.bbgsdjrdh"
				label="对接人电话"
				placeholder="输入对接人电话"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入对接人电话' }]"
			/>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.select" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onload"
				@check="check"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
	</div>
</template>

<script>
import popupselect from "@/components/select/index";
import { getList } from "@/api/review";
import { Toast } from "vant";

export default {
	name: "report",
	components: {
		"popup-select": popupselect
	},
	data() {
		return {
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			client_id_text: "",
			form: {
				client_id: "",
				xmmc: "",
				xmbh: "",
				xmxh: "",
				xmcchzmj: "",
				xmdz: "",
				bbgs: "",
				sfgw: "",
				bbgsdjr: "",
				bbgsdjrdh: ""
			},
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 25
			},
			processList: [],
			popup: {
				process: false,
				select: false
			}
		};
	},
	mounted() {
		this.getReportList();
	},
	methods: {
		onSubmit() {
			this.$emit("sub", {
				requestType: "process_apply",
				process_id: this.process_id,
				apply_data: JSON.stringify(this.form),
				apply_rmb:  "0"
			});
		},
		getReportList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		check(value) {
			this.popup.select = false;
			this.client_id_text = value.client_name;
			this.form.client_id = value.client_id;
		},
		onload(search) {
			if (search != undefined) {
				this.clientList.page = 1;
			}
			getList({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
		}
	}
};
</script>